import type { AnalyticsBuilderFieldSetType, AnalyticsBuilderTemplateType } from '@/types';
import AnalyticsBuilder from './AnalyticsBuilder';

type AnalyticsBuilderListProps = {
  prompts: AnalyticsBuilderTemplateType[];
  fieldSets: AnalyticsBuilderFieldSetType[];
  className?: string;
};

const AnalyticsBuilderList = ({ prompts, fieldSets, className }: AnalyticsBuilderListProps) => (
  <div className={className}>
    {prompts.map((prompt, index) => (
      <AnalyticsBuilder
        key={prompt.urlSegement || prompt.displayName || index}
        prompt={prompt}
        fieldSets={fieldSets}
        promptIndex={index}
      >
        {(openPrompt) => (
          <div
            className="group h-full cursor-pointer rounded-md border border-gray-200 bg-[#f4f5f7] transition hover:shadow-sm"
            onClick={openPrompt}
          >
            <div className="flex h-full flex-col p-6">
              <h4 className="mb-3 text-xl font-semibold text-zinc-950">{prompt.displayName}</h4>
              <div
                className="flex-1 leading-6 text-zinc-600"
                dangerouslySetInnerHTML={{ __html: prompt.description }}
              />

              <div className="flex items-center justify-end border-t border-zinc-100 pt-4">
                <span className="text-sm font-medium text-zinc-950">Generate report</span>
              </div>
            </div>
          </div>
        )}
      </AnalyticsBuilder>
    ))}
  </div>
);

export default AnalyticsBuilderList;
